import React, { useState, useRef } from "react";
import { Container, Card, Form, Button, Toast } from "react-bootstrap";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";

const ContactPage = () => {
	const formRef = useRef();
	const recaptchaRef = useRef();
	const [sending, setSending] = useState(false);
	const [showToast, setShowToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [toastVariant, setToastVariant] = useState("success");

	const handleSubmit = async (e) => {
		e.preventDefault();

		const recaptchaValue = recaptchaRef.current.getValue();
		if (!recaptchaValue) {
			setToastMessage("Please verify that you are not a robot.");
			setToastVariant("danger");
			setShowToast(true);
			return;
		}

		setSending(true);

		try {
			await emailjs.sendForm("get2know", "get2know", formRef.current, "B0V4MwBj-aNHhQo4D");

			setToastMessage("Your message was sent successfully!");
			setToastVariant("success");
			setShowToast(true);
			formRef.current.reset();
			recaptchaRef.current.reset(); // reset captcha after submission
		} catch (error) {
			console.error("Email send error:", error);
			setToastMessage("Something went wrong. Please try again later.");
			setToastVariant("danger");
			setShowToast(true);
		} finally {
			setSending(false);
		}
	};

	return (
		<Container className="py-3">
			<Card className="mx-auto shadow-lg p-4" style={{ maxWidth: "600px", borderRadius: "1rem" }}>
				<Card.Body>
					<h2 className="text-center mb-4">Contact Us</h2>
					<p className="text-center text-muted mb-4">
						Have a question or want to work together? Fill out the form below.
					</p>

					<Form ref={formRef} onSubmit={handleSubmit}>
						<Form.Group className="mb-3">
							<Form.Label>Name</Form.Label>
							<Form.Control type="text" name="user_name" placeholder="Your name" required />
						</Form.Group>

						<Form.Group className="mb-3">
							<Form.Label>Email</Form.Label>
							<Form.Control type="email" name="user_email" placeholder="Your email" required />
						</Form.Group>

						<Form.Group className="mb-3">
							<Form.Label>Subject</Form.Label>
							<Form.Control type="text" name="subject" placeholder="Subject" required />
						</Form.Group>

						<Form.Group className="mb-4">
							<Form.Label>Message</Form.Label>
							<Form.Control as="textarea" name="message" rows={4} placeholder="Write your message..." required />
						</Form.Group>

						{/* ✅ reCAPTCHA */}
						<div className="mb-3 text-center">
							<ReCAPTCHA sitekey="6LceIucrAAAAAKXCEk8vWHTanskHtDWbPO-NKeQ7" ref={recaptchaRef} />
						</div>

						<div className="text-center">
							<Button
								className="my-btn"
								type="submit"
								disabled={sending}
								style={{ width: "50%", borderRadius: "25px" }}
							>
								{sending ? "Sending..." : "Send Message"}
							</Button>
						</div>
					</Form>
				</Card.Body>
			</Card>

			<Card className="mt-3 text-center shadow-sm border-0 small-owner-card">
				<Card.Body>
					<p className="mb-2 text-muted">
						This app is owned by <strong>John Moran</strong>
					</p>

					<a
						href="https://www.linkedin.com/in/artworkjpm/"
						target="_blank"
						rel="noopener noreferrer"
						className="linkedin-link"
					>
						<i className="bi bi-linkedin me-2"></i>
						Connect on LinkedIn
					</a>
				</Card.Body>
			</Card>

			<Toast
				show={showToast}
				bg={toastVariant}
				onClose={() => setShowToast(false)}
				delay={3000}
				autohide
				className="position-fixed bottom-0 end-0 m-4 text-white"
			>
				<Toast.Body>
					{toastVariant === "success" ? (
						<i className="bi bi-check-circle-fill me-2"></i>
					) : (
						<i className="bi bi-x-circle-fill me-2"></i>
					)}
					{toastMessage}
				</Toast.Body>
			</Toast>
		</Container>
	);
};

export default ContactPage;
